import React, { useEffect, useState } from "react";
import API, { CONFIG, UPDATE_CONFIG } from "../../network/api";
import { TEXT_DEF } from "../../constant/text";
import { Button, Switch, DatePicker } from "antd";
import ModalCommon from "../../components/Modal";
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';

dayjs.extend(utc);
dayjs.extend(timezone);

const TEXT = {
    onOffGame: "Bật/Tắt game",
    eventStartTime: "Thời gian bắt đầu sự kiện",
    eventEndTime: "Thời gian kết thúc sự kiện",
}

const OnOffGame = () => {
    const [configGame, setConfigGame] = useState();
    const [isShowModalConfirm, setIsShowModalConfirm] = useState(false);
    const [isShowModalSuccess, setIsShowModalSuccess] = useState(false);

    const [dateFrom, setDateFrom] = useState();
    const [dateTo, setDateTo] = useState();
    const [isShowGame, setIsShowGame] = useState();

    useEffect(() => {
        getDataConfig();
    }, []);

    const getDataConfig = async () => {
        try {
            const res = await API.get(`${CONFIG}`);
            const data = res.data.data;
            setConfigGame({
                isGameEnabled: data.isGameEnabled,
                eventStart: data.eventStart,
                eventEnd: data.eventEnd
            });
        } catch (err) {
            console.log(err);
        }
    };

    const handleUpdateConfig = async () => {
        try {
            setIsShowModalConfirm(false);
            setIsShowModalSuccess(true);
            const body = {
                config : {
                    isGameEnabled: isShowGame,
                    eventStart: dateFrom ? formatRequest(dateFrom) : configGame?.eventStart,
                    eventEnd: dateTo ? formatRequest(dateTo) : configGame?.eventEnd
                }
            };
            
            await API.patch(`${UPDATE_CONFIG}`, body);
        } catch (err) {
            console.log(err);
        }
    };

    const formatRequest = (dateFm) => {
        const date = dayjs.tz(dateFm, 'YYYY-MM-DD HH:mm:ss', 'Asia/Bangkok');
        const output = date.format('YYYY-MM-DDTHH:mm:ss.SSSZ');
        return output
    }

    const handleShowModal = () => {
        setIsShowModalConfirm(true);
    };

    const onChangeDate = (value, type) => {
        if (value) {
            const formatted = value.format("YYYY-MM-DD HH:mm:ss");
            if (type === "from") setDateFrom(formatted);
            else setDateTo(formatted);
        } else if (type === "from") {
            setDateFrom(null);
        } else {
            setDateTo(null);
        }
    };

    const checkFlagShow = () => {
        const isCheck = configGame.isGameEnabled;
        return isCheck;
    };

    const handleChangeSwitch = (e) => {
        setIsShowGame(e);
    };

    return (
        <div className="col-12">
            <div className="col-12">
                <div className="flex w-full">
                    <div className="flex flex-col w-full items-center justify-center">
                        <div className="col-10 mt-2 flex flex-col items-center justify-center">
                            <div className="flex w-full items-center">
                                <div className="flex w-[20%] justify-end mr-10">{TEXT.onOffGame}:</div>
                                {configGame?.eventStart && <div className="w-[60%]">
                                    <Switch
                                        checkedChildren="On"
                                        unCheckedChildren="Off"
                                        defaultChecked={checkFlagShow()}
                                        style={{ width: 60, marginTop: "5px" }}
                                        onChange={(e) => handleChangeSwitch(e)}
                                    />
                                </div>}
                            </div>
                            {configGame?.eventStart && <div className="flex w-full items-center mt-4">
                                <div className="flex w-[20%] justify-end mr-10">{TEXT.eventStartTime}:</div>
                                <div className="w-[60%]">
                                    <DatePicker
                                        placeholder=""
                                        onChange={(value) => onChangeDate(value, "from")}
                                        defaultValue={dayjs(configGame?.eventStart, "YYYY-MM-DD HH:mm:ss")}
                                        format={"DD-MM-YYYY HH:mm:ss"}
                                        style={{ width: "100%" }}
                                        disabledDate={(d) =>
                                            !d ||
                                            (dateTo
                                              ? d.isAfter(dayjs(dateTo), "day")
                                              : false)
                                        }
                                        showTime
                                    />
                                </div>
                            </div>}
                            {configGame?.eventEnd && <div className="flex w-full items-center mt-4">
                                <div className="flex w-[20%] justify-end mr-10">{TEXT.eventEndTime}:</div>
                                <div className="w-[60%]">
                                    <DatePicker
                                        placeholder=""
                                        defaultValue={dayjs(configGame?.eventEnd, "YYYY-MM-DD HH:mm:ss")}
                                        onChange={(value) => onChangeDate(value, "to")}
                                        format={"DD-MM-YYYY HH:mm:ss"}
                                        style={{ width: "100%" }}
                                        disabledDate={(d) =>
                                            !d ||
                                            (dateFrom
                                              ? d.isBefore(dayjs(dateFrom), "day")
                                              : false)
                                        }
                                        showTime
                                    />
                                </div>
                            </div>}
                        </div>
                        <div className="col-10 mt-5 flex items-center justify-center">
                            <Button type="primary" onClick={handleShowModal}>
                                Cập nhật
                            </Button>
                        </div>
                    </div>
                </div>
            </div>
            {isShowModalConfirm && (
                <ModalCommon
                    isShow={isShowModalConfirm}
                    message={TEXT_DEF.text0062}
                    txtBtnAcc={TEXT_DEF.text0008}
                    textBtnClose={TEXT_DEF.text0023}
                    actionNext={handleUpdateConfig}
                    close={() => setIsShowModalConfirm(false)}
                />
            )}
            {isShowModalSuccess && (
                <ModalCommon
                    isShow={isShowModalSuccess}
                    message={TEXT_DEF.text0063}
                    txtBtnAcc={TEXT_DEF.text0007}
                    actionNext={() => {
                        setIsShowModalSuccess(false);
                    }}
                    close={() => {
                        setIsShowModalSuccess(false);
                    }}
                />
            )}
        </div>
    );
};

export default OnOffGame;
